export const isNumeric = (n) => {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

export const isBase64Encoded = (str) => {
	let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
	return base64regex.test(str);
}